import {
  Form,
  notification
} from 'antd'
import React, { useEffect, useState } from 'react'
import { useDataPokemon } from "../../../../Hooks/Admin";
import { useEditarPokemon } from "../queries/useEditarPokemon";
import {
  useSelectTipoPokemon,
  useSelectPokemonOriginal,
} from "../queries/useSelectsPokemon";
import { useImagenesPokemon } from "../queries/useImagenesPokemon";
import {
  EmptyState,
  PokemonHeader,
  PokemonFormCard
} from './Components';
import './DataPokemon.css';

export const DataPokemon = ({ id, onGoToImagenes }) => {
  const [form] = Form.useForm();
  const [canEdit, setCanEdit] = useState(false);
  const [detalleDatos, setDetalleDatos] = useState(null);

  const { data, isLoading, refetch } = useDataPokemon(id);
  const { data: imagenes } = useImagenesPokemon(id);
  const editarPokemon = useEditarPokemon();

  // Hooks para selects
  const tiposPrincipal = useSelectTipoPokemon();
  const preevoluciones = useSelectPokemonOriginal();

  useEffect(() => {
    if (data) {
      const mergedData = { ...data };
      if (data.detalle) {
        mergedData.depo_descripcion = data.detalle.depo_descripcion;
        mergedData.depo_altura = data.detalle.depo_altura;
        mergedData.depo_peso = data.detalle.depo_peso;
        mergedData.depo_seudonimo = data.detalle.depo_seudonimo;
      }
      // Combinar la imagen desde imagenesPokemon
      if (imagenes?.imagUrl) {
        mergedData.imagen = imagenes.imagUrl;
      }
      form.setFieldsValue(mergedData);
      setDetalleDatos(mergedData);
    }

  }, [data, imagenes, form]);

  // Actualizar imagen cuando imagenes cambia
  useEffect(() => {
    if (imagenes?.imagUrl && detalleDatos) {
      setDetalleDatos(prev => ({ ...prev, imagen: imagenes.imagUrl }));
    }
  }, [imagenes]);

  const submitEditarPokemon = async (values) => {
    try {
      const params = { ...values, idPokemon: id };
      console.log(params);
      await editarPokemon.mutateAsync(params);

      notification.success({
        message: 'Pokémon actualizado',
        description: 'Los cambios se han guardado correctamente',
        placement: 'topRight'
      });

      await refetch();
      setCanEdit(false);
    } catch (error) {
      // Verificar si el error es por número de Pokédex duplicado (409)
      const mensaje = error?.response?.data?.mensaje || error?.response?.data?.datos || null;
      if (error?.response?.status === 409 && mensaje) {
        form.setFields([
          {
            name: 'poke_numero_pokedex',
            errors: [mensaje],
          },
        ]);
      } else {
        notification.error({
          message: 'Error al actualizar Pokémon',
          description: 'Ocurrió un error al guardar los cambios',
          placement: 'topRight'
        });
      }
    }
  };

  const handleToggleEdit = () => {
    setCanEdit(!canEdit);
  };

  const handleCancelEdit = () => {
    setCanEdit(false);
    if (detalleDatos) {
      form.setFieldsValue(detalleDatos);
    }
  };

  // Estados de renderizado
  if (!id) {
    return <EmptyState type="select" />;
  }

  if (isLoading) {
    return <EmptyState type="loading" />;
  }

  if (!detalleDatos) {
    return <EmptyState type="noData" />;
  }
  return (
    <div data-testid="data-pokemon-panel">
      <PokemonHeader
        detalleDatos={detalleDatos}
        canEdit={canEdit}
        onToggleEdit={handleToggleEdit}
        onGoToImagenes={onGoToImagenes}
      />
      <PokemonFormCard
        canEdit={canEdit}
        form={form}
        detalleDatos={detalleDatos}
        tiposPrincipal={tiposPrincipal}
        preevoluciones={preevoluciones}
        onSubmit={submitEditarPokemon}
        onCancel={handleCancelEdit}
        isLoading={editarPokemon.isLoading}
      />
    </div>
  );
};
